import { useState } from 'react';

import { useBooking } from 'app/hooks/data/core/admin/bookings/useBooking';
import { useResendHotelMail } from 'app/hooks/data/core/admin/bookings/useResendHotelMail';
import { useResendUserMail } from 'app/hooks/data/core/admin/bookings/useResendUserMail';
import type { Feedback as FeedbackType } from 'app/typings/adminBookings/bookingFeedback';
import { ISSUING_TRANSACTION_STATUS } from 'app/typings/core/common/enum/issuingTransactionStatus';
import { ISSUING_TRANSACTION_TYPE } from 'app/typings/core/common/enum/issuingTransactionType';

export const useBookingDetails = (bookingCode: string) => {
  const {
    data: bookingDetails,
    isLoading,
    refetch: reloadBooking,
  } = useBooking(bookingCode);

  const { mutateAsync: resendUserConfirmationMail } =
    useResendUserMail(bookingCode);

  const { mutateAsync: resendHotelConfirmationMail } =
    useResendHotelMail(bookingCode);

  const [refundModalVisible, setRefundModalVisible] = useState(false);
  const [isVoucherModalVisible, setIsVoucherModalVisible] = useState(false);
  const [isEditEmailModalVisible, setIsEditEmailModalVisible] = useState(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isEditReviewModalVisible, setIsEditReviewModalVisible] =
    useState(false);
  const [feedbackInModal, setFeedbackInModal] = useState<
    FeedbackType | undefined
  >(undefined);

  const booking = bookingDetails?.booking;

  const isVccBooking = Boolean(booking?.issuingCardId);

  const isVccCharged =
    isVccBooking &&
    (booking?.issuingTransactions ?? []).some(
      (transaction) =>
        transaction.type === ISSUING_TRANSACTION_TYPE.CAPTURE &&
        transaction.status === ISSUING_TRANSACTION_STATUS.VALIDATED
    );

  return {
    bookingDetails,
    isLoading,
    reloadBooking,
    resendUserConfirmationMail,
    resendHotelConfirmationMail,
    refundModalVisible,
    setRefundModalVisible,
    isVoucherModalVisible,
    setIsVoucherModalVisible,
    isEditEmailModalVisible,
    setIsEditEmailModalVisible,
    isCancelModalVisible,
    setIsCancelModalVisible,
    feedbackInModal,
    setFeedbackInModal,
    isVccBooking,
    isVccCharged,
    isEditReviewModalVisible,
    setIsEditReviewModalVisible,
  };
};
